var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndeedReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.indeed{fill:url(#indeed-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "indeed-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42004,
    stopColor: "#05599e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#004d94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262262"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "indeed",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M69.94122,36.28375h-10.05713v-3.72455c0-2.14789-1.74652-3.89441-3.89441-3.89441h-11.97937c-2.14734,0-3.89441,1.74652-3.89441,3.89441v3.72455h-10.05713c-1.17773,0-2.13245.95471-2.13245,2.13245v30.7865c0,1.17767.95471,2.13245,2.13245,2.13245h39.88245c1.17773,0,2.13245-.95477,2.13245-2.13245v-30.7865c0-1.17773-.95471-2.13245-2.13245-2.13245ZM43.44836,32.5592c0-.31024.25171-.56189.56195-.56189h11.97937c.31024,0,.56195.25165.56195.56189v3.72455h-13.10327v-3.72455ZM58.41687,52.78705l-3.06073,3.31689.52643,4.48242c.11505.97937-.88629,1.70703-1.7821,1.29492l-4.10052-1.88593-4.10034,1.88593c-.89587.41211-1.89728-.31555-1.78229-1.29492l.52661-4.48242-3.06073-3.31689c-.6687-.72473-.28619-1.90192.68079-2.09515l4.42572-.88446,2.2088-3.93591c.48254-.85986,1.7204-.85986,2.203,0l2.2088,3.93591,4.42578.88446c.96692.19324,1.34949,1.37042.68079,2.09515Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeedReviewsScraper);
export default __webpack_public_path__ + "static/media/indeed-reviews-scraper.4f56b477f82dd3136aafa8bdbe84413a.svg";
export { ForwardRef as ReactComponent };